import React from 'react'
import {
  Grid,
  GridCell,
  Link,
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  Badge,
  Tooltip,
  TEXT_VARIANT_LIGHT,
  IconPaperPlane,
  Chip,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { abTestState, tagsListState } from '../recoil/state/abTest'
import { useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import { useHistory } from 'react-router-dom'

const StyledFailedLink = styled(Link)`
  position: relative;
  top: 5px;
  left: 8px;
`

const StyledFailedIcon = styled(IconPaperPlane)`
  border-radius: 100%;
  padding: 7px 8px 7px 6px;
  background-color: var(--sunset-orange);
  position: absolute;
  top: -9px;
  svg {
    path {
      fill: #ffffff !important;
    }
  }
`

const AbTestInfo = () => {
  const intl = useIntl()
  const history = useHistory()
  const { Info, Tags, existsFailedSending } = useRecoilValue(abTestState)
  const { tagsList } = useRecoilValue(tagsListState)

  const statusCheck = stato => {
    switch (stato) {
      case 0:
      case 3:
      case 6:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusDraft' })}
            type='default'
          />
        )
      case 4:
      case 5:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusLoadingTest' })}
            type='warning'
          />
        )
      case 7:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusScheduled' })}
            type='info'
          />
        )
      case 1:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusTestRunning' })}
            type='warning'
          />
        )
      case 11:
      case 12:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusTestEnded' })}
            type='success'
          />
        )
      case 2:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusWinnerRunning' })}
            type='warning'
          />
        )
      case 14:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusFinished' })}
            type='success'
          />
        )
      case 13:
        return (
          <Badge
            text={intl.formatMessage({
              id: 'Load.AbTest.StatusWinnerScheduled'
            })}
            type='info'
          />
        )
      case 15:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusTestAborted' })}
            type='error'
          />
        )
      case 16:
        return (
          <Badge
            text={intl.formatMessage({
              id: 'Load.AbTest.StatusWinnerMailingAborted'
            })}
            type='error'
          />
        )
      case -1:
      case -2:
        return (
          <Badge
            text={intl.formatMessage({ id: 'Load.AbTest.StatusLoadingFailed' })}
            type='error'
          />
        )
      default:
        return null
    }
  }

  const goToSendStatus = () => {
    history.push('/messages/email/sendstatus/campaigns')
  }

  return (
    <Panel collapsible={false}>
      <Tooltip />
      <Grid cols={12}>
        {/* prima riga */}
        <GridCell span={3}>
          <Flex>
            <FlexItem margin='0 16px 0 0'>
              <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Status' })}
              </Text>
            </FlexItem>
            {statusCheck(Info.Stato)}
            {existsFailedSending && (
              <>
                <StyledFailedLink
                  onClick={goToSendStatus}
                  data-mu-test='AbtestManage-MessageisFailed'
                >
                  <StyledFailedIcon
                    data-tip={intl.formatMessage({
                      id: 'Load.AbTest.MessageisFailedTooltip'
                    })}
                  />
                </StyledFailedLink>
              </>
            )}
          </Flex>
        </GridCell>
        <GridCell span={Info.TipoTest !== 'X' && Tags.length <= 0 ? 5 : 9}>
          <Flex>
            <FlexItem margin='0 16px 0 0'>
              <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.AbTest.TestStartDate' })}
              </Text>
            </FlexItem>
            <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
              {Info.TestDateCTZScheduled &&
                Info.TestDateCTZScheduled.replace('T', ' ')
                  .replace('Z', ' ')
                  .split('.')[0]}{' '}
              {Info.TimeZoneScheduled.split('.')[0]}
              {!Info.TestDateCTZScheduled && '-'}
            </Text>
          </Flex>
        </GridCell>
        {Info.TipoTest !== 'X' && Tags.length <= 0 && (
          <GridCell span={4}>
            <Flex>
              <FlexItem margin='0 16px 0 0'>
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: 'Load.ABTestWizard.PickTagsWinner'
                  })}
                </Text>
              </FlexItem>
              <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                -
              </Text>
            </Flex>
          </GridCell>
        )}

        {/* seconda riga */}
        <GridCell span={3}>
          {' '}
          <Flex>
            <FlexItem margin='0 16px 0 0'>
              <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Type' })}
              </Text>
            </FlexItem>{' '}
            <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
              {Info.TipoTest === 'A' && (
                <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.AbTest.TypeAuto' })}
                </Text>
              )}
              {Info.TipoTest === 'M' && (
                <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.AbTest.TypeManual' })}
                </Text>
              )}
              {Info.TipoTest === 'X' && (
                <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.AbTest.Type100' })}
                </Text>
              )}
            </Text>
          </Flex>
        </GridCell>
        <GridCell span={5}>
          {' '}
          <Flex>
            <FlexItem margin='0 16px 0 0'>
              <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.AbTest.RecipientPerc' })}
              </Text>
            </FlexItem>
            <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
              {intl.formatNumber(Info.PercTest)}%
            </Text>
          </Flex>
        </GridCell>
        {Info.TipoTest === 'A' && (
          <GridCell span={4}>
            <Flex>
              <FlexItem margin='0 16px 0 0'>
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({ id: 'Load.AbTest.Criteria' })}
                </Text>
              </FlexItem>{' '}
              {Info.Criterio === 1 && (
                <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.ABTestWizard.Criteria1' })}
                </Text>
              )}
              {Info.Criterio === 2 && (
                <Text htmlElement='span' variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({ id: 'Load.ABTestWizard.Criteria2' })}
                </Text>
              )}
            </Flex>
          </GridCell>
        )}

        {/* terza riga */}
        {Info.TipoTest !== 'X' && Tags.length > 0 && (
          <>
            {Tags.length > 0 && (
              <GridCell span={12}>
                <Flex>
                  <FlexItem margin='0 16px 0 0'>
                    <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                      {intl.formatMessage({
                        id: 'Load.ABTestWizard.PickTagsWinner'
                      })}
                    </Text>
                  </FlexItem>
                  {Tags.map((tag, key) => (
                    <>
                      {tagsList.find(t => t.Id === tag) && (
                        <Chip
                          label={tagsList.find(t => t.Id === tag).Name}
                          key={key}
                        />
                      )}
                    </>
                  ))}
                </Flex>
              </GridCell>
            )}
          </>
        )}
      </Grid>
    </Panel>
  )
}

export default AbTestInfo
